<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-date-picker
            v-model="date"
            type="daterange"
            :max-day-length="180"
            :clearable="false"
            tooltip="数据时间"
        ></gj-date-picker>
        <gj-select
            v-model="strategyStatus"
            :options="AdStrategyStatusEnum.option"
            placeholder="分时策略"
        ></gj-select>
        <template #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :data="tableData"
          :columns="columns"
          :loading="loading"
          sortable="custom"
          :default-sort="defaultSort"
          :offset-height="58"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:belongGroup="{row}">
          <app-sp-ad-route-link
              :ad-group-manager="{marketId, campaign: row, group: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.groupName">
              {{row.groupName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sp-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:op="{row}">
          <template v-if="AdPlacementEnum.SP.type.Other === row.placement || !$permission('adsStrategyObject:add') || isMeaningless(row.percentage)">-</template>
          <gj-button
              v-else
              type="text"
              @click="timeAdjust(row)">
            分时策略
          </gj-button>
          <gj-button-group
              v-if="false"
              type="dropdown-op">
            <gj-button type="text" @click="timeAdjust(row)">分时策略</gj-button>
            <template #dropdown>
              <gj-dropdown-item @click="viewAdjustLog(row)">调价日志</gj-dropdown-item>
            </template>
          </gj-button-group>
        </template>
        <template v-slot:adjustments="{ row }">
          {{ row.percentage | defaultShow('', '%') }}
          <AdEditBidPlacement
            :value="row"
            :updateValue="updateBid"
            :isEdit="row.placement != 'Other'">
          </AdEditBidPlacement>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "../../../common/fields";
  import {
    adDefaultSortMixin,
    currencySymbolMixin,
    inCampaignMixin, initDateMixin,
    inMarketMixin, resizeMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {permissionChangeMixin, queryMixin, responseMixin, selectionMixin} from "../../../../../../minxins";
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../../../utils/common";
  import {subDays} from 'date-fns';
  import AppSpAdRouteLink from "../../common/components/ad-route-link";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {adStore} from "../../../common/store";
  import {
    addAdsAdjustStrategy,
    updateAdsAdjustStrategyObject,
    getSpAdPlacement,
    SP,
    batchUpdateStrategyObject
  } from "../../../../../../api/ad";
  import {AdPlacementEnum, AdStrategyStatusEnum, AdLog} from "../../../common/enum";
  import AppAdTimeAdjustStrategyOpModal
    from "../../../strategy/time-adjust/modal/strategy-op/time-adjust-strategy-op-modal";
  import {OpEnum} from "../../../../../../utils/options";
  import {optionText} from "../../../../../../filters";
  import {AdStrategyEnum} from "../../../strategy/common/enum";
  import AdEditBidPlacement from "modules/ad/common/components/ad-edit-bid-placement.vue";
  import AppAdLogModal from "../../../common/modal/log/ad-log-new-modal";

  export default {
    name: "app-sp-ad-placement",
    components: {AppSpAdRouteLink, AdEditBidPlacement},
    mixins: [
      inMarketMixin, inCampaignMixin, resizeMixin,
      tableNameMixin, queryMixin, responseMixin, selectionMixin,
      currencySymbolMixin, adDefaultSortMixin,
      permissionChangeMixin, initDateMixin
    ],
    created() {
      this.columns = [
        {...adFields.placement, options: AdPlacementEnum.SP.placementOption},
        {...adFields.bidStrategy, options: AdPlacementEnum.SP.bidStrategyOption},
        {...adFields.strategyStatus, field: 'option:strategyStatus', options: AdStrategyStatusEnum.option},
        {...adFields.bidAdjust, field: 'slot:adjustments'},
        // adFields.bid,
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.sales,
        adFields.acos,
        adFields.cvr,
        adFields.cpa,
        adFields.roas,
        {...adFields.op, width: '70px', permission: 'adsStrategyObject:add'},
      ];
    },
    data() {
      return {
        helpName:'spadmanager',
        tableData: [],
        columns: [],
        // filter
        date: [subDays(new Date(), 6), new Date()],
        AdPlacementEnum: AdPlacementEnum,
        AdStrategyStatusEnum: AdStrategyStatusEnum,
        strategyStatus: null,
      }
    },
    methods: {
      isMeaningless,
      // 操作日志
      viewLog() {
        let campaignId = this.campaignId || row?.campaignId;
        this.$gjCreate(AppAdLogModal, {
          props: {
            campaignId,
            marketId: this.marketId,
            adType: 'SP',
            objectType: AdLog().objCell.space,
          }
        });
      },
      // 广告组修改
      async placementEdit(param) {
        const params = {
          marketId: this.marketId,
          ...param
        }
        try {
          const { data, msg, isError} = await SP.placementEdit(params);
          this.$gjMessage[isError ? 'error' : 'success'](msg);
          this.clearCheckboxRow();
          let element = this.tableData.find(e => (e.placement === data.placement && e.campaignId === data.campaignId));
          Object.assign(element, data);
        } catch (error) {
          console.log(error)
        }
      },
      // 更新竞价
      async updateBid(val, row) {
        const params = {
          campaignId: row.campaignId,
          placement: row.placement,
          percentage: val
        }
        await this.placementEdit(params);
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          strategyStatus: null,
          date: this.initDate || [subDays(new Date(), 6), new Date()]
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) {
          return;
        }
        // 构造查询参数
        const params = {
          marketId: this.marketId,
          campaignId: this.campaignId,
          startDate: convertToDate(this.date[0]),
          endDate: convertToDate(this.date[1]),
          strategyStatus: defaultVal(this.strategyStatus, null),
        };
        // 查询
        this.loading = true;
        SP.placementPage(params)
          .then(({data}) => {
            if (isMeaningful(data)) {
              if (isMeaningful(this.sort.order)) {
                const prop = this.sort.prop;
                data.sort((e1, e2) => {
                  if (this.sort.order === 'descending') {
                    return Number(e2[prop]) - Number(e1[prop]);
                  } else if (this.sort.order === 'ascending') {
                    return Number(e1[prop]) - Number(e2[prop]);
                  }
                });
              }
              this.tableData = this.currencySymbolMixin(data, adStore.SP.currencySymbol);
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
      // 广告策略
      timeAdjust(row) {
        const modal = this.$gjCreate(AppAdTimeAdjustStrategyOpModal, {
          props: {
            title: `<span>分时策略</span><span class="modal-secondary-title">(${optionText(row.placement, AdPlacementEnum.SP.placementOption)})</span>`,
            opType: OpEnum.type.USE,
            item: row,
            objectId: row.objectId,
            strategyType: 2,// 1：广告组、关键词、商品投放、投放组， 2：广告位， 3：广告活动
          },
          on: {
            updated: () => {
              this.$gjMessage.success('操作成功');
              modal.$gjDestroy();
              this.$gjResetPage()
            },
            useStrategy: ({params, status, templateId, callback, resumeDTO}) => {
              modal.confirmLoading = true;
              let useParams;
              Promise.resolve(row.strategyStatus)
                      .then((strategyStatus) => {
                        if (strategyStatus === AdStrategyStatusEnum.NO_ADD) {
                          useParams = {
                            resumeDTO,
                            id: row.objectId,
                            adsStrategyTemplate: params,
                            marketId: row.marketId,
                            bid: row.adjustments,
                            status,
                            templateId,
                            campaignId: row.campaignId,
                            campaignName: row.campaignName,
                            groupId: row.groupId,
                            groupName: row.groupName,
                            objectId: row.campaignId,
                            objectName: optionText(row.placement, AdPlacementEnum.SP.placementOption, 'id', 'realId'),
                            objectType: AdStrategyEnum.objectType.PLACEMENT
                          }
                          return addAdsAdjustStrategy(useParams)
                        } else {
                          useParams = [{
                            ...params,
                            marketId: row.marketId,
                            objectPid: row.objectId,
                            objectStatus: status,
                            templatePId:templateId,
                          }]
                          return batchUpdateStrategyObject(useParams)
                        }
                      })
                      .then((res) => {
                        if (callback) {
                          callback(res);
                        }
                      })
                .complete(() => modal.confirmLoading = false);
            }
          }
        })
      },
      viewAdjustLog(row) {

      }
    }
  }
</script>

<style scoped>

</style>
